// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.FqcHqL {
  display: grid;
  grid-template-columns: minmax(0, 1fr) minmax(0, 1fr);
  align-items: center;
  gap: 40px;
  height: 272px;
}
.Gdn4kk {
  height: 272px;
  width: 100%;
  border-radius: var(--radius-m);
  overflow: hidden;
  display: flex;
  align-items: center;
}
.Gdn4kk img {
  width: 346.5px;
  height: 272px;
  max-width: none;
}
.FqcHqL h1 {
  width: 100%;
  font-family: var(--font-family-clario);
  font-size: 32px;
  font-weight: 500;
  line-height: 38px;
  margin: 0;
}
.FqcHqL strong {
  color: var(--text-primary-medium);
  font-weight: inherit;
}
.um8zcH {
  font-size: 16px;
  line-height: 23px;
  margin: 0;
}
.eKE6np {
  display: grid;
  grid-template-columns: repeat(4, minmax(0, 1fr));
  gap: 24px;
  padding: 0 0.5px;
}
.eKE6np > div {
  height: 165px;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 10px;
  padding: 24px 12px;
  text-align: center;
}
.eKE6np span {
  display: grid;
  place-items: center;
  flex-shrink: 0;
  background: var(--surface-neutral-subtle);
  border-radius: var(--radius-pill);
  width: 42px;
  height: 42px;
}
.eKE6np img {
  width: 21.5px;
  height: auto;
}
.eKE6np > div:nth-child(2) img {
  width: 20.9038px;
  transform: translateX(-0.2019px);
}
.eKE6np > div:nth-child(3) img {
  width: 20.5px;
  transform: translateY(-0.12195px);
}
.eKE6np p strong {
  font-weight: 500;
}
.eKE6np p {
  width: 100%;
  font-size: 14px;
  line-height: 20px;
  margin: 0;
}
.xljruw {
  position: relative;
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 24px;
  padding-top: 11px;
}
.xljruw section {
  position: relative;
  border-radius: 4px;
  padding: 24px;
  display: flex;
  flex-direction: column;
  align-items: center;
}
.hv1IB5 {
  background: var(--surface-primary-subtle);
}
.udmOl2 {
  background: var(--color-action-blue-100, #ebf1ff);
}
.rAh7UM {
  position: absolute;
  top: -11px;
  transform: translateX(-1.75px);
  width: 97px;
  height: 24px;
  display: grid;
  place-items: center;
  background: var(--surface-primary-medium);
  color: var(--text-neutral-white);
  border-radius: 20.238px;
  font-family: var(--font-family-clario);
  font-size: 11px;
  font-weight: 400;
  line-height: 12px;
  z-index: 1;
}
.LmXCQM {
  position: relative;
  width: 116.235px;
  height: 72.4364px;
  margin-bottom: 16px;
}
.LmXCQM img {
  width: 117px;
  height: 73px;
  max-width: none;
}
.WvwNPQ > .zqUXn6 {
  position: relative;
  height: 18px;
}
.zqUXn6 img {
  position: absolute;
  width: 19.3551px;
  height: 17.3559px;
  left: 0.302px;
  top: 0.3672px;
  transform: scaleY(-1);
}
.WvwNPQ {
  width: 100%;
  height: 110px;
  padding-bottom: 16px;
  margin-bottom: 16px;
  border-bottom: 1px solid #ffb280;
  display: flex;
  flex-direction: column;
  gap: 2px;
}
.WvwNPQ + .WvwNPQ {
  height: 110px;
}
.WvwNPQ:last-child {
  height: 93px;
  border-bottom: 0;
  padding-bottom: 0;
  margin-bottom: 0;
}
.udmOl2 .WvwNPQ {
  border-color: #5ca4fd;
}
.WvwNPQ > :first-child {
  width: 20px;
  height: 20px;
  flex-shrink: 0;
}
.WvwNPQ h3 {
  font-size: 14px;
  font-weight: 600;
  line-height: 25px;
  margin: 0;
}
.WvwNPQ p {
  font-size: 12px;
  line-height: 1.6;
  margin: 0;
}
.jkuTx4 {
  object-fit: contain;
}
.jE8E_g {
  display: grid;
  grid-template-columns: minmax(0, 260fr) minmax(0, 449fr);
  gap: 24px;
  min-height: 500px;
}
._Ecaj9 {
  position: relative;
  overflow: hidden;
  border-radius: 8px;
}
.uVcmi_ {
  height: 102.47%;
  width: 281.85%;
  max-width: none;
  position: absolute;
  left: -46.77%;
  top: -0.05%;
}
.qj1r44 {
  position: absolute;
  width: 726px;
  height: 726px;
  max-width: none;
  left: -195px;
  top: -249.436px;
  pointer-events: none;
}
.jE8E_g section {
  background: var(--surface-neutral-subtle);
  padding: 32px 40px;
  border-radius: 8px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  gap: 24px;
}
.jE8E_g h2 {
  width: max-content;
  max-width: 100%;
  font-family: var(--font-family-clario);
  font-size: 32px;
  font-weight: 500;
  line-height: 32px;
  margin: 0;
}
.jE8E_g strong {
  color: var(--text-primary-medium);
  font-weight: 700;
}
.jE8E_g p {
  display: flex;
  align-items: start;
  gap: 12px;
  font-size: 16px;
  line-height: 23px;
  margin: 0;
  color: #000;
}
.jE8E_g b {
  font-size: 15px;
  font-weight: 700;
  line-height: 21px;
}
.jE8E_g p img {
  width: 21.5px;
  height: auto;
  flex-shrink: 0;
}
.FBUvKn {
  display: flex;
  flex-direction: column;
  gap: 24px;
  padding: 24px;
  border-radius: 8px;
  background: #fff0e5;
}
.tnZldr {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 12px;
}
.tnZldr p {
  align-self: stretch;
}
.FBUvKn img {
  width: 21.5px;
  height: auto;
}
.FBUvKn p {
  margin: 0;
  font-size: 16px;
  line-height: 23px;
  text-align: center;
  color: #000;
}
.FBUvKn a {
  color: var(--text-primary-medium);
  text-decoration: underline;
  text-underline-position: from-font;
  text-align: center;
  font-size: 16px;
  font-weight: 500;
  line-height: 24px;
}
@media (max-width: 767px) {
  .FqcHqL,
  .jE8E_g {
    grid-template-columns: 1fr;
    height: auto;
  }
  .Gdn4kk,
  .FqcHqL h1 {
    width: 100%;
  }
  .Gdn4kk img {
    max-width: 100%;
    height: auto;
  }
  ._Ecaj9 {
    min-height: 500px;
  }
  .eKE6np {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
  .xljruw {
    grid-template-columns: 1fr;
    gap: 24px;
  }
  .WvwNPQ,
  .WvwNPQ + .WvwNPQ,
  .WvwNPQ:last-child {
    height: auto;
    min-height: 109px;
    padding-bottom: 16px;
  }
}

.VN6Azu {
  position: relative;
}
.VN6Azu img {
  position: absolute;
  max-width: none;
}
.s_ZB1Q img {
  left: 1.758px;
  top: 5.4216px;
}
.GhbgOF img {
  left: 0;
  top: 1.7506px;
}
.Z7apX6 img {
  left: 1.25px;
  top: 1.7536px;
}
.CJaUFe img {
  left: 1.25px;
  top: 0.5px;
}
.RwpZu4 img {
  left: -1.25px;
  top: 1.7506px;
}

.oqhDTd {
  width: 21.5px;
  height: 21.5px;
}
`, "",{"version":3,"sources":["webpack://./../../packages/beneficios/src/pages/BenefitMigrationPage/components/MigrationIntroduction.module.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,oDAAoD;EACpD,mBAAmB;EACnB,SAAS;EACT,aAAa;AACf;AACA;EACE,aAAa;EACb,WAAW;EACX,8BAA8B;EAC9B,gBAAgB;EAChB,aAAa;EACb,mBAAmB;AACrB;AACA;EACE,cAAc;EACd,aAAa;EACb,eAAe;AACjB;AACA;EACE,WAAW;EACX,sCAAsC;EACtC,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,SAAS;AACX;AACA;EACE,iCAAiC;EACjC,oBAAoB;AACtB;AACA;EACE,eAAe;EACf,iBAAiB;EACjB,SAAS;AACX;AACA;EACE,aAAa;EACb,gDAAgD;EAChD,SAAS;EACT,gBAAgB;AAClB;AACA;EACE,aAAa;EACb,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,SAAS;EACT,kBAAkB;EAClB,kBAAkB;AACpB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,cAAc;EACd,yCAAyC;EACzC,iCAAiC;EACjC,WAAW;EACX,YAAY;AACd;AACA;EACE,aAAa;EACb,YAAY;AACd;AACA;EACE,gBAAgB;EAChB,gCAAgC;AAClC;AACA;EACE,aAAa;EACb,iCAAiC;AACnC;AACA;EACE,gBAAgB;AAClB;AACA;EACE,WAAW;EACX,eAAe;EACf,iBAAiB;EACjB,SAAS;AACX;AACA;EACE,kBAAkB;EAClB,aAAa;EACb,gDAAgD;EAChD,SAAS;EACT,iBAAiB;AACnB;AACA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,aAAa;EACb,aAAa;EACb,sBAAsB;EACtB,mBAAmB;AACrB;AACA;EACE,yCAAyC;AAC3C;AACA;EACE,iDAAiD;AACnD;AACA;EACE,kBAAkB;EAClB,UAAU;EACV,8BAA8B;EAC9B,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,yCAAyC;EACzC,gCAAgC;EAChC,uBAAuB;EACvB,sCAAsC;EACtC,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,UAAU;AACZ;AACA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;EACjB,mBAAmB;AACrB;AACA;EACE,YAAY;EACZ,YAAY;EACZ,eAAe;AACjB;AACA;EACE,kBAAkB;EAClB,YAAY;AACd;AACA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;EACjB,aAAa;EACb,aAAa;EACb,qBAAqB;AACvB;AACA;EACE,WAAW;EACX,aAAa;EACb,oBAAoB;EACpB,mBAAmB;EACnB,gCAAgC;EAChC,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;AACA;EACE,aAAa;AACf;AACA;EACE,YAAY;EACZ,gBAAgB;EAChB,iBAAiB;EACjB,gBAAgB;AAClB;AACA;EACE,qBAAqB;AACvB;AACA;EACE,WAAW;EACX,YAAY;EACZ,cAAc;AAChB;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,SAAS;AACX;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,SAAS;AACX;AACA;EACE,mBAAmB;AACrB;AACA;EACE,aAAa;EACb,wDAAwD;EACxD,SAAS;EACT,iBAAiB;AACnB;AACA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;AACpB;AACA;EACE,eAAe;EACf,cAAc;EACd,eAAe;EACf,kBAAkB;EAClB,aAAa;EACb,WAAW;AACb;AACA;EACE,kBAAkB;EAClB,YAAY;EACZ,aAAa;EACb,eAAe;EACf,YAAY;EACZ,eAAe;EACf,oBAAoB;AACtB;AACA;EACE,yCAAyC;EACzC,kBAAkB;EAClB,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,SAAS;AACX;AACA;EACE,kBAAkB;EAClB,eAAe;EACf,sCAAsC;EACtC,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,SAAS;AACX;AACA;EACE,iCAAiC;EACjC,gBAAgB;AAClB;AACA;EACE,aAAa;EACb,kBAAkB;EAClB,SAAS;EACT,eAAe;EACf,iBAAiB;EACjB,SAAS;EACT,WAAW;AACb;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,iBAAiB;AACnB;AACA;EACE,aAAa;EACb,YAAY;EACZ,cAAc;AAChB;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,aAAa;EACb,kBAAkB;EAClB,mBAAmB;AACrB;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,SAAS;AACX;AACA;EACE,mBAAmB;AACrB;AACA;EACE,aAAa;EACb,YAAY;AACd;AACA;EACE,SAAS;EACT,eAAe;EACf,iBAAiB;EACjB,kBAAkB;EAClB,WAAW;AACb;AACA;EACE,iCAAiC;EACjC,0BAA0B;EAC1B,kCAAkC;EAClC,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,iBAAiB;AACnB;AACA;EACE;;IAEE,0BAA0B;IAC1B,YAAY;EACd;EACA;;IAEE,WAAW;EACb;EACA;IACE,eAAe;IACf,YAAY;EACd;EACA;IACE,iBAAiB;EACnB;EACA;IACE,gDAAgD;EAClD;EACA;IACE,0BAA0B;IAC1B,SAAS;EACX;EACA;;;IAGE,YAAY;IACZ,iBAAiB;IACjB,oBAAoB;EACtB;AACF;;AAEA;EACE,kBAAkB;AACpB;AACA;EACE,kBAAkB;EAClB,eAAe;AACjB;AACA;EACE,aAAa;EACb,aAAa;AACf;AACA;EACE,OAAO;EACP,aAAa;AACf;AACA;EACE,YAAY;EACZ,aAAa;AACf;AACA;EACE,YAAY;EACZ,UAAU;AACZ;AACA;EACE,aAAa;EACb,aAAa;AACf;;AAEA;EACE,aAAa;EACb,cAAc;AAChB","sourcesContent":[".hero {\n  display: grid;\n  grid-template-columns: minmax(0, 1fr) minmax(0, 1fr);\n  align-items: center;\n  gap: 40px;\n  height: 272px;\n}\n.heroImage {\n  height: 272px;\n  width: 100%;\n  border-radius: var(--radius-m);\n  overflow: hidden;\n  display: flex;\n  align-items: center;\n}\n.heroImage img {\n  width: 346.5px;\n  height: 272px;\n  max-width: none;\n}\n.hero h1 {\n  width: 100%;\n  font-family: var(--font-family-clario);\n  font-size: 32px;\n  font-weight: 500;\n  line-height: 38px;\n  margin: 0;\n}\n.hero strong {\n  color: var(--text-primary-medium);\n  font-weight: inherit;\n}\n.description {\n  font-size: 16px;\n  line-height: 23px;\n  margin: 0;\n}\n.features {\n  display: grid;\n  grid-template-columns: repeat(4, minmax(0, 1fr));\n  gap: 24px;\n  padding: 0 0.5px;\n}\n.features > div {\n  height: 165px;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 10px;\n  padding: 24px 12px;\n  text-align: center;\n}\n.features span {\n  display: grid;\n  place-items: center;\n  flex-shrink: 0;\n  background: var(--surface-neutral-subtle);\n  border-radius: var(--radius-pill);\n  width: 42px;\n  height: 42px;\n}\n.features img {\n  width: 21.5px;\n  height: auto;\n}\n.features > div:nth-child(2) img {\n  width: 20.9038px;\n  transform: translateX(-0.2019px);\n}\n.features > div:nth-child(3) img {\n  width: 20.5px;\n  transform: translateY(-0.12195px);\n}\n.features p strong {\n  font-weight: 500;\n}\n.features p {\n  width: 100%;\n  font-size: 14px;\n  line-height: 20px;\n  margin: 0;\n}\n.comparison {\n  position: relative;\n  display: grid;\n  grid-template-columns: repeat(2, minmax(0, 1fr));\n  gap: 24px;\n  padding-top: 11px;\n}\n.comparison section {\n  position: relative;\n  border-radius: 4px;\n  padding: 24px;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n}\n.vr {\n  background: var(--surface-primary-subtle);\n}\n.emissor {\n  background: var(--color-action-blue-100, #ebf1ff);\n}\n.badge {\n  position: absolute;\n  top: -11px;\n  transform: translateX(-1.75px);\n  width: 97px;\n  height: 24px;\n  display: grid;\n  place-items: center;\n  background: var(--surface-primary-medium);\n  color: var(--text-neutral-white);\n  border-radius: 20.238px;\n  font-family: var(--font-family-clario);\n  font-size: 11px;\n  font-weight: 400;\n  line-height: 12px;\n  z-index: 1;\n}\n.cardImage {\n  position: relative;\n  width: 116.235px;\n  height: 72.4364px;\n  margin-bottom: 16px;\n}\n.cardImage img {\n  width: 117px;\n  height: 73px;\n  max-width: none;\n}\n.row > .vrLogo {\n  position: relative;\n  height: 18px;\n}\n.vrLogo img {\n  position: absolute;\n  width: 19.3551px;\n  height: 17.3559px;\n  left: 0.302px;\n  top: 0.3672px;\n  transform: scaleY(-1);\n}\n.row {\n  width: 100%;\n  height: 110px;\n  padding-bottom: 16px;\n  margin-bottom: 16px;\n  border-bottom: 1px solid #ffb280;\n  display: flex;\n  flex-direction: column;\n  gap: 2px;\n}\n.row + .row {\n  height: 110px;\n}\n.row:last-child {\n  height: 93px;\n  border-bottom: 0;\n  padding-bottom: 0;\n  margin-bottom: 0;\n}\n.emissor .row {\n  border-color: #5ca4fd;\n}\n.row > :first-child {\n  width: 20px;\n  height: 20px;\n  flex-shrink: 0;\n}\n.row h3 {\n  font-size: 14px;\n  font-weight: 600;\n  line-height: 25px;\n  margin: 0;\n}\n.row p {\n  font-size: 12px;\n  line-height: 1.6;\n  margin: 0;\n}\n.rowIcon {\n  object-fit: contain;\n}\n.how {\n  display: grid;\n  grid-template-columns: minmax(0, 260fr) minmax(0, 449fr);\n  gap: 24px;\n  min-height: 500px;\n}\n.person {\n  position: relative;\n  overflow: hidden;\n  border-radius: 8px;\n}\n.personImage {\n  height: 102.47%;\n  width: 281.85%;\n  max-width: none;\n  position: absolute;\n  left: -46.77%;\n  top: -0.05%;\n}\n.pattern {\n  position: absolute;\n  width: 726px;\n  height: 726px;\n  max-width: none;\n  left: -195px;\n  top: -249.436px;\n  pointer-events: none;\n}\n.how section {\n  background: var(--surface-neutral-subtle);\n  padding: 32px 40px;\n  border-radius: 8px;\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  gap: 24px;\n}\n.how h2 {\n  width: max-content;\n  max-width: 100%;\n  font-family: var(--font-family-clario);\n  font-size: 32px;\n  font-weight: 500;\n  line-height: 32px;\n  margin: 0;\n}\n.how strong {\n  color: var(--text-primary-medium);\n  font-weight: 700;\n}\n.how p {\n  display: flex;\n  align-items: start;\n  gap: 12px;\n  font-size: 16px;\n  line-height: 23px;\n  margin: 0;\n  color: #000;\n}\n.how b {\n  font-size: 15px;\n  font-weight: 700;\n  line-height: 21px;\n}\n.how p img {\n  width: 21.5px;\n  height: auto;\n  flex-shrink: 0;\n}\n.support {\n  display: flex;\n  flex-direction: column;\n  gap: 24px;\n  padding: 24px;\n  border-radius: 8px;\n  background: #fff0e5;\n}\n.supportContact {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 12px;\n}\n.supportContact p {\n  align-self: stretch;\n}\n.support img {\n  width: 21.5px;\n  height: auto;\n}\n.support p {\n  margin: 0;\n  font-size: 16px;\n  line-height: 23px;\n  text-align: center;\n  color: #000;\n}\n.support a {\n  color: var(--text-primary-medium);\n  text-decoration: underline;\n  text-underline-position: from-font;\n  text-align: center;\n  font-size: 16px;\n  font-weight: 500;\n  line-height: 24px;\n}\n@media (max-width: 767px) {\n  .hero,\n  .how {\n    grid-template-columns: 1fr;\n    height: auto;\n  }\n  .heroImage,\n  .hero h1 {\n    width: 100%;\n  }\n  .heroImage img {\n    max-width: 100%;\n    height: auto;\n  }\n  .person {\n    min-height: 500px;\n  }\n  .features {\n    grid-template-columns: repeat(2, minmax(0, 1fr));\n  }\n  .comparison {\n    grid-template-columns: 1fr;\n    gap: 24px;\n  }\n  .row,\n  .row + .row,\n  .row:last-child {\n    height: auto;\n    min-height: 109px;\n    padding-bottom: 16px;\n  }\n}\n\n.glyph {\n  position: relative;\n}\n.glyph img {\n  position: absolute;\n  max-width: none;\n}\n.glyph0 img {\n  left: 1.758px;\n  top: 5.4216px;\n}\n.glyph1 img {\n  left: 0;\n  top: 1.7506px;\n}\n.glyph2 img {\n  left: 1.25px;\n  top: 1.7536px;\n}\n.glyph3 img {\n  left: 1.25px;\n  top: 0.5px;\n}\n.glyph4 img {\n  left: -1.25px;\n  top: 1.7506px;\n}\n\n.supportIcon {\n  width: 21.5px;\n  height: 21.5px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"hero": `FqcHqL`,
	"heroImage": `Gdn4kk`,
	"description": `um8zcH`,
	"features": `eKE6np`,
	"comparison": `xljruw`,
	"vr": `hv1IB5`,
	"emissor": `udmOl2`,
	"badge": `rAh7UM`,
	"cardImage": `LmXCQM`,
	"row": `WvwNPQ`,
	"vrLogo": `zqUXn6`,
	"rowIcon": `jkuTx4`,
	"how": `jE8E_g`,
	"person": `_Ecaj9`,
	"personImage": `uVcmi_`,
	"pattern": `qj1r44`,
	"support": `FBUvKn`,
	"supportContact": `tnZldr`,
	"glyph": `VN6Azu`,
	"glyph0": `s_ZB1Q`,
	"glyph1": `GhbgOF`,
	"glyph2": `Z7apX6`,
	"glyph3": `CJaUFe`,
	"glyph4": `RwpZu4`,
	"supportIcon": `oqhDTd`
};
module.exports = ___CSS_LOADER_EXPORT___;
